import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import id from "./id";
import ru from "./ru";
import zh from "./zh";
import ko from "./ko";
import fr from "./fr";
import de from "./de";
import nl from "./nl";

const language = JSON.parse(localStorage.getItem("@wirasana_lang"));

i18n.use(initReactI18next).init({
  resources: {
    en: en,
    id: id,
    ru: ru,
    zh: zh,
    ko: ko,
    fr: fr,
    de: de,
    nl: nl,
  },
  lng: language?.value || "en", // Bahasa default
  fallbackLng: "en", // Bahasa cadangan
  interpolation: {
    escapeValue: false, // Biarkan HTML di dalam terjemahan
  },
});

export default i18n;
